export const TEST_IDS = {
  HERO_SKELETON: 'hero-skeleton',
  MENU_BUTTON_DESKTOP: 'menu-button-desktop',
  HEADER_ACTION_LINKS: 'app-listing__header-action-links',
  SERVER_EOL_MESSAGE: 'server-eol-warning-message',
  SERVER_EOS_MESSAGE: 'server-eos-warning-message',
} as const;
